/**
 * RefsHubPage — landing page tổng hợp cho tất cả ref tables (Sprint 5).
 */
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import BadgeIcon from '@mui/icons-material/Badge'
import CalculateIcon from '@mui/icons-material/Calculate'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import InventoryIcon from '@mui/icons-material/Inventory'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import StarIcon from '@mui/icons-material/Star'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import TuneIcon from '@mui/icons-material/Tune'
import UpdateIcon from '@mui/icons-material/Update'
import VerifiedIcon from '@mui/icons-material/Verified'
import { Link } from 'react-router-dom'
import type { SvgIconComponent } from '@mui/icons-material'
import { CARD_GRID_PROGRESSIVE } from '@/theme/responsive'

interface RefCard {
  text: string
  path: string
  Icon: SvgIconComponent
}

const REF_CARDS: RefCard[] = [
  { text: 'Banks', path: '/refs/banks', Icon: AccountBalanceIcon },
  { text: 'Certifications', path: '/purchase/refs/certifications', Icon: VerifiedIcon },
  { text: 'Delivery Places', path: '/purchase/refs/delivery-places', Icon: LocationOnIcon },
  { text: 'Delivery Terms', path: '/purchase/refs/delivery-terms', Icon: LocalShippingIcon },
  { text: 'Packages', path: '/purchase/refs/packages', Icon: InventoryIcon },
  { text: 'Adjust Lots', path: '/purchase/refs/adjust-lots', Icon: TuneIcon },
  { text: 'Licenses', path: '/purchase/refs/licenses', Icon: BadgeIcon },
  { text: 'Qualities', path: '/purchase/refs/qualities', Icon: StarIcon },
  { text: 'Updates', path: '/purchase/refs/updates', Icon: UpdateIcon },
  { text: 'Calendars', path: '/purchase/refs/calendars', Icon: CalendarMonthIcon },
  { text: 'Futures Orders', path: '/purchase/refs/futures-orders', Icon: TrendingUpIcon },
  { text: 'Valuation', path: '/purchase/refs/valuations', Icon: CalculateIcon },
]

export function RefsHubPage() {
  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="h5" fontWeight={700}>
        Reference Tables
      </Typography>
      <Box sx={{ ...CARD_GRID_PROGRESSIVE, gap: 2 }}>
        {REF_CARDS.map(({ text, path, Icon }) => (
          <Card
            key={path}
            elevation={2}
          >
            <CardActionArea component={Link} to={path} sx={{ height: '100%' }}>
              <CardContent>
                <Box display="flex" flexDirection="column" alignItems="center" gap={1} py={1}>
                  <Icon sx={{ fontSize: 40, color: 'primary.main' }} />
                  <Typography variant="subtitle2" textAlign="center" fontWeight={600}>
                    {text}
                  </Typography>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  )
}

export default RefsHubPage
